<template>
  <div @click.stop.self.prevent :ref="`wrapper`" class="map-wrapper">
    <div class="detail center-hv" v-if="resizing">
      W: {{ scaleDisplay.width }}, H: {{ scaleDisplay.height }}
    </div>
    <div
      @mouseover="initMouseOver('t')"
      ref="t"
      class="resize-dot top"
    ></div>
    <div
      @mouseover="initMouseOver('b')"
      ref="b"
      class="resize-dot bottom"
    ></div>
    <div
      @mouseover="initMouseOver('l')"
      ref="l"
      class="resize-dot left"
    ></div>
    <div
      @mouseover="initMouseOver('r')"
      ref="r"
      class="resize-dot right"
    ></div>
    <div
      @mouseover="initMouseOver('tl')"
      ref="tl"
      class="resize-dot top-left"
    ></div>
    <div
      @mouseover="initMouseOver('tr')"
      ref="tr"
      class="resize-dot top-right"
    ></div>
    <div
      @mouseover="initMouseOver('bl')"
      ref="bl"
      class="resize-dot bottom-left"
    ></div>
    <div
      @mouseover="initMouseOver('br')"
      ref="br"
      class="resize-dot bottom-right"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["component"],
  components: {},
  watch: {
    mouseup() {
      this.closeDragElement();
    },
  },
  computed: {
    ...mapGetters({
      mouseup: "designIframe/windowEvent/mouseup",
      screenSize: "screenSize",
    }),
    isMobile() {
      return this.screenSize.toLowerCase() == 'mobile'
    },
    componentId() {
      return this.component.id;
    },
    width: {
      get() {
        return this.isMobile ? this.component.styleMobile.width : this.component.style.width
      },
      set(value) {
        if (this.isMobile) {
          this.component.styleMobile.width = value;
        } else {
          this.component.style.width = value;
        }
        this.$store.dispatch("design/snapshot/genSnapshot");
      },
    },
    height: {
      get() {
        return this.isMobile ? this.component.styleMobile.height : this.component.style.height
      },
      set(value) {
        if (this.isMobile) {
          this.component.styleMobile.height = value;
        } else {
          this.component.style.height = value;
        }
        this.$store.dispatch("design/snapshot/genSnapshot");
      },
    },
    scaleDisplay() {
      let mapWrapper = document.getElementsByClassName("map-wrapper")[0]
      let mapWidth = mapWrapper.getBoundingClientRect().width
      let mapHeight = mapWrapper.getBoundingClientRect().height
      return {
        width: this.width ? this.width : mapWidth,
        height: this.height ? this.height : mapHeight,
      }
    }
  },
  data() {
    return {
      ratio: 1,
      resizeDirection: undefined,
      resizing: false,
      positionTopStart: undefined,
      positionBottomStart: undefined,
      positionLeftStart: undefined,
      positionRightStart: undefined,
      cellWidth: undefined,
    };
  },
  mounted () {
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    initMouseOver(ref) {
      this.dragElement(ref);
    },
    dragElement(ref) {
      if (this.$refs[ref]) {
        this.resizeDirection = ref;
        this.$refs[ref].onmousedown = this.dragMouseDown;
      }
    },
    dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      this.resizing = true;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
      let width = document.getElementsByClassName("map-wrapper")[0].clientWidth
      this.ratio = width / this.height;
      this.positionTopStart = document.getElementsByClassName("map-wrapper")[0].getBoundingClientRect().top
      this.positionBottomStart = document.getElementsByClassName("map-wrapper")[0].getBoundingClientRect().bottom
      this.positionLeftStart = document.getElementsByClassName("map-wrapper")[0].getBoundingClientRect().left
      this.positionRightStart = document.getElementsByClassName("map-wrapper")[0].getBoundingClientRect().right
      
      let cell = document.getElementsByClassName("map-container")[0].parentNode.parentNode;
      this.cellWidth = cell.getBoundingClientRect().width
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      let diffval = 0;
      const width = document.getElementsByClassName("map-wrapper")[0].getBoundingClientRect().width;
      const height = document.getElementsByClassName("map-wrapper")[0].getBoundingClientRect().height;

      switch (this.resizeDirection) {
        case "t":
          this.width = parseInt(width);
          this.height = parseInt(this.positionBottomStart - this.pos4);
          break;
        case "b":
          this.width = parseInt(width);
          this.height = parseInt(this.pos4 - this.positionTopStart);
          break;
        case "l":
          this.width = parseInt(this.positionRightStart - this.pos3);
          this.height = parseInt(height);
          break;
        case "r":
          this.width = parseInt(this.pos3 - this.positionLeftStart);
          this.height = parseInt(height);
          break;
        case "tl":
          diffval = this.pos2 + this.pos1;
          this.width = parseInt(width + diffval);
          this.height = parseInt(this.width / this.ratio);
          break;
        case "br":
          diffval = this.pos2 + this.pos1;
          this.width = parseInt(width - diffval);
          this.height = parseInt(this.width / this.ratio);
          break;
        case "tr":
          diffval = this.pos1 - this.pos2;
          this.width = parseInt(width - diffval);
          this.height = parseInt(this.width / this.ratio);
          break;
        case "bl":
          diffval = this.pos1 - this.pos2;
          this.width = parseInt(width + diffval);
          this.height = parseInt(this.width / this.ratio);
          break;
        default:
          break;
      }
      
      if (this.width < 200) {
        this.width = 200;
        if (this.resizeDirection == 'tl' || this.resizeDirection == 'tr' || this.resizeDirection == 'bl' || this.resizeDirection == 'br') {
          this.height = parseInt(this.width / this.ratio);
        } else {
          this.height = parseInt(height)
        }
      } else if (this.height < 200) {
        this.height = 200;
        if (this.resizeDirection == 'tl' || this.resizeDirection == 'tr' || this.resizeDirection == 'bl' || this.resizeDirection == 'br') {
          this.width = parseInt(this.height * this.ratio);
        } else {
          this.width = parseInt(width)
        } 
      } else if (this.width > this.cellWidth) {
        this.width = this.cellWidth
      }

      this.$emit("callbackResize");
    },

    closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
      this.resizing = false;
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        this.closeDragElement()
      }
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 10;
}
.map-wrapper .detail {
  background-color: #ffffff;
  color: #12A9FF;
  width: fit-content;
  padding: 4px 8px;
  position: absolute;
  border-radius: 4px;
}
.map-wrapper .resize-dot{
  pointer-events: all;
  width: 8px;
  height: 8px;
  background-color: #ffffff;
  position: absolute;
  border: 1px solid #12A9FF;
}
.map-wrapper .resize-dot.top {
  top: 0;
  left: 50%;
  margin-top: -4px;
  cursor: ns-resize;
}
.map-wrapper .resize-dot.bottom {
  bottom: 0;
  left: 50%;
  margin-bottom: -4px;
  cursor: ns-resize;
}
.map-wrapper .resize-dot.left {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  margin-left: -4px;
  cursor: ew-resize;
}
.map-wrapper .resize-dot.right {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  margin-right: -4px;
  cursor: ew-resize;
}
.map-wrapper .resize-dot.top-left {
  top: 0;
  left: 0;
  margin-top: -4px;
  margin-left: 0px;
  cursor: nwse-resize;
}
.map-wrapper .resize-dot.top-right {
  top: 0;
  right: 0;
  margin-top: -4px;
  margin-right: -8px;
  cursor: nesw-resize;
}
.map-wrapper .resize-dot.bottom-left {
  bottom: 0px;
  margin-bottom: -4px;
  margin-left: 0px;
  cursor: nesw-resize;
}
.map-wrapper .resize-dot.bottom-right{
  bottom: 0;
  right: 0;
  margin-bottom: -4px;
  margin-right: -8px;
  cursor: nwse-resize;
}


</style>